import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import commonModule from './modules/common'
import energyModule from './modules/energy'
import consumptionModule from './modules/consumption'
import calculationModule from './modules/calculation'
import contactModule from './modules/contact'
import comparisonModule from './modules/comparison'
import simulationModule from './modules/simulation'
import podiumModule from './modules/podium'
import middlewareModule from './modules/middleware'
import themeModule from './modules/theme'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
  supportCircular: true,
})

export default new Vuex.Store({
  modules: {
    common: commonModule,
    energy: energyModule,
    consumption: consumptionModule,
    calculation: calculationModule,
    contact: contactModule,
    comparison: comparisonModule,
    simulation: simulationModule,
    podium: podiumModule,
    middleware: middlewareModule,
    theme: themeModule
  },
  plugins: [vuexLocal.plugin]
});


// WEBPACK FOOTER //
// ./src/store/index.js